export const LOCKED_LIST_SUCCESS = "LOCKED_LIST_SUCCESS";
export const LOCKED_LIST_LOADING = "LOCKED_LIST_LOADING";
export const LOCKED_LIST_FAILED = "LOCKED_LIST_FAILED";
export const LOCKED_LIST_LOADDATA = "LOCKED_LIST_LOADDATA";
